<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.9581 0.759111C10.9581 0.164958 11.5757 -0.198146 12.0536 0.115071L17.6608 3.90977C18.1131 4.20619 18.1131 4.90143 17.6608 5.19785L12.0536 8.88493C11.5757 9.19815 10.9581 8.83504 10.9581 8.24089V5.7571L1.0247 5.75684C0.568579 5.75684 8.13989e-07 5.07184 8.13989e-07 4.55398C8.13989e-07 4.03612 0.568579 3.35078 1.0247 3.35078L10.9581 3.35105V0.759111Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.04187 9.75911C7.04187 9.16496 6.42428 8.80185 5.94645 9.11507L0.339157 12.9098C-0.113052 13.2062 -0.113052 13.9014 0.339157 14.1979L5.94645 17.8849C6.42428 18.1981 7.04187 17.835 7.04187 17.2409V14.7571L16.9753 14.7568C17.4314 14.7568 18 14.0718 18 13.554C18 13.0361 17.4314 12.3508 16.9753 12.3508L7.04187 12.351V9.75911Z"
    />
  </svg>
</template>
